import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  OnChanges,
  SimpleChanges,
  ViewChild,
  input,
  output,
} from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { AssetDto, GalleryDto } from '@nusign/picflow-backend-types';
import { delay, map } from 'rxjs';
import { NonPreviewFileComponent } from '../../../gallery/components/non-preview-file/non-preview-file.component';
import { sleep } from '../../../lib/sleep';
import { ClickOutsideDirective } from '../../../shared-extra/directives/click-outside.directive';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { InViewDirective } from '../../../shared/directives/in-view.directive';
import { InViewNewDirective } from '../../../shared/directives/in-view.directive-new';
import { AssetVersionUrlPipe } from '../../../shared/pipes/asset-version-url.pipe';
import { CanDisplayAssetPipe } from '../../pipes/can-display-asset.pipe';

@Component({
  selector: 'app-thumbnail-bar',
  templateUrl: './thumbnail-bar.component.html',
  styleUrls: ['./thumbnail-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ClickOutsideDirective,
    SvgComponent,
    CanDisplayAssetPipe,
    NonPreviewFileComponent,
    AssetVersionUrlPipe,
    InViewDirective,
    InViewNewDirective,
  ],
})
export class ThumbnailBarComponent implements OnChanges {
  @ViewChild('bar') barEl: ElementRef<HTMLDivElement>;
  readonly gallery = input.required<GalleryDto>();
  readonly assets = input.required<AssetDto[]>();
  readonly selectedAssetId = input.required<string>();
  onClose = output<void>();
  onSwitchToAsset = output<string>();
  loadMoreBefore = output();
  loadMoreAfter = output();

  readonly allowLoadingExtra = toSignal(
    toObservable(this.assets).pipe(
      delay(10),
      map(() => true)
    )
  );

  async ngOnChanges(changes: SimpleChanges) {
    if (!changes['selectedAssetId']) return;
    if (!this.selectedAssetId()) return;
    await sleep(0);
    const el = this.barEl.nativeElement.querySelector(`#thumb-${this.selectedAssetId()}`);
    if (el) {
      el.scrollIntoView({
        behavior: changes.selectedAssetId.isFirstChange() ? 'instant' : 'smooth',
        block: 'nearest',
        inline: 'center',
      });
    }
  }
}
